export interface DropdownSelectList {
    id: number;
    name: string;
    url: string;
}

export interface InfoCardList {
    name: string;
    icon: string;
    description: string;
    url?: string;
    options?: DropdownSelectList[];
}

export interface ProductCardList {
    id: string;
    name: string;
    icon: string;
    description: string;
    url?: string;
}

export interface AccessProductCardList {
    description: string;
    icon: string;
    id: string;
    name: string;

    createUrl(environment: Environment | null): string;
}

export interface RawApiResponse {
    packageName: PackageName;
    products: ProductAccess[];
}

export enum PackageName {
    ESSENTIALS = 'ESSENTIALS',
    SUITE = 'SUITE',
}

export enum Product {
    ENGAGE = 'ENGAGE',
    PUBLISH = 'PUBLISH',
    CONSUMER_RESEARCH = 'CONSUMER_RESEARCH',
    ADMINISTRATION = 'ADMINISTRATION',
    ADVERTISE = 'ADVERTISE',
    MEASURE = 'MEASURE',
    AUDIENCE = 'AUDIENCE',
    LISTEN = 'LISTEN',
    BENCHMARK = 'BENCHMARK',
    INFLUENCE = 'INFLUENCE',
    VIZIA = 'VIZIA',
}

export enum Environment {
    STAGING = 'STAGING',
    PRODUCTION = 'PRODUCTION',
}

export interface ProductAccess {
    product: Product;
    userHasAccess: boolean;
}
